import React from 'react';

export type HeaderActionVariant = 'primary' | 'success' | 'secondary' | 'danger';

const VARIANT_CLASSES: Record<HeaderActionVariant, string> = {
  // Acción principal oscura (ej: Conectar)
  primary:
    'bg-black text-white hover:bg-gray-800 dark:bg-white dark:text-black dark:hover:bg-gray-200 border border-transparent',
  // Acción de arranque (ej: Iniciar)
  success:
    'bg-green-600 dark:bg-green-500 text-white hover:bg-green-700 dark:hover:bg-green-600 border border-transparent',
  // Acción secundaria de contorno (ej: Detener, Reiniciar)
  secondary:
    'bg-transparent border border-gray-300 dark:border-gray-600 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700',
  // Acción destructiva de contorno
  danger:
    'bg-transparent border border-red-300 dark:border-red-700 text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20',
};

export interface HeaderActionButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: HeaderActionVariant;
  icon?: React.ReactNode;
  /** Oculta el texto en pantallas pequeñas dejando solo el icono */
  hideLabelOnMobile?: boolean;
}

/**
 * Botón estándar para las acciones del header de páginas de detalle.
 * Tamaño y estilo unificados en VM, Deploy App, Database, Marketplace, etc.
 */
const HeaderActionButton: React.FC<HeaderActionButtonProps> = ({
  variant = 'secondary',
  icon,
  hideLabelOnMobile = false,
  children,
  className = '',
  type = 'button',
  ...rest
}) => {
  return (
    <button
      type={type}
      {...rest}
      className={`flex items-center gap-2 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${VARIANT_CLASSES[variant]} ${className}`}
    >
      {icon}
      {children != null && (
        <span className={hideLabelOnMobile ? 'hidden sm:inline' : undefined}>
          {children}
        </span>
      )}
    </button>
  );
};

export default HeaderActionButton;
